import React from 'react';

import { FormControl, Grid, InputLabel, MenuItem, Select, SelectChangeEvent, TextField } from '@mui/material';

import { LoyaltyProgramConfig, LoyaltyProgramRow as LoyaltyProgramRowType } from './loyaltyProgramsConfig';

interface Props {
  row: LoyaltyProgramRowType;
  programConfigMap: Record<string, LoyaltyProgramConfig>;
  availablePrograms: Array<string>;
  onUpdate: (field: 'program' | 'memberNumber', value: string) => void;
  isSubmitting: boolean;
}

export default function LoyaltyProgramRow({ row, programConfigMap, availablePrograms, onUpdate, isSubmitting }: Props) {
  const handleProgramChange = (event: SelectChangeEvent<string>) => {
    onUpdate('program', event.target.value);
  };

  const handleMemberNumberChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onUpdate('memberNumber', event.target.value);
  };

  const programLabel = row.type === 'flight' ? 'Frequent flyer' : 'Hotel loyalty program';

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={6}>
        <FormControl fullWidth>
          <InputLabel>{programLabel} (optional)</InputLabel>
          <Select
            value={row.program || ''}
            label={`${programLabel} (optional)`}
            onChange={handleProgramChange}
            disabled={isSubmitting}
          >
            {availablePrograms.map((programKey) => {
              const config = programConfigMap[programKey];
              return (
                <MenuItem key={programKey} value={programKey}>
                  {config.name}
                </MenuItem>
              );
            })}
          </Select>
        </FormControl>
      </Grid>

      <Grid item xs={12} md={6}>
        <TextField
          fullWidth
          label="Membership number (optional)"
          placeholder="Enter membership number"
          value={row.memberNumber}
          onChange={handleMemberNumberChange}
          disabled={!row.program || isSubmitting}
        />
      </Grid>
    </Grid>
  );
}
